// File: src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import PrivateRoute from "./auth/PrivateRoute";
import awsExports from "./aws-exports";
import { Amplify } from "aws-amplify"; 
import { AuthProvider } from "./context/AuthContext";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.1";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
}

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
  <DataProvider>
  <BrowserRouter>
  
     <Routes>
       {/* public auth screens (login, register, etc) */}
       <Route path="/auth/*" element={<AuthLayout />} />

       {/* all /admin/* routes require login */}
       <Route
         path="/admin/*"
         element={
           <PrivateRoute>
             <AdminLayout />
           </PrivateRoute>
         }
       />

       {/* any other URL → /admin/dashboard if logged in, else /auth/login */}
       <Route
         path="*"
         element={<Navigate to="/admin/dashboard" replace />}
       />
     </Routes>
  </BrowserRouter>
  </DataProvider>
  </AuthProvider>
);
